import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getActivePath } from "lib/utils/navigation";

const useNavigation = (
  navigationData: NavigationData[] = []
): Omit<
  NavigationContextValue,
  "setWorkflowDisabled" | "setEnableCustomDashboard" | "setUserOpExists"
> => {
  const { pathname } = useLocation();
  const initialPath = getActivePath(pathname, navigationData);
  const [activePath, setActivePath] = useState(initialPath);
  const [isVerticalOpen, setVerticalOpen] = useState(true);

  useEffect(() => {
    const path = getActivePath(pathname, navigationData);
    setActivePath(path);
  }, [pathname, navigationData]);

  const toggleVerticalOpen = () => {
    setVerticalOpen((prevState) => !prevState);
  };

  return {
    activePath,
    isVerticalOpen,
    setVerticalOpen,
    toggleVerticalOpen,
  };
};

export default useNavigation;
